<template>
  <div class="map" ref="map"></div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'map',
  props: ['dark'],
  computed: mapGetters({
    lang: 'lang',
  }),
  mounted() {
    this.detectLang();
  },
  watch: {
    lang() {
      this.detectLang();
    },
  },
  methods: {
    detectLang() {
      const lang = this.lang === 0 ? 'ru' : 'en';
      if (!this.dark) {
        this.updateLang(lang);
      }
    },
    initMap() {
      const google = window.google;
      const mapOptions = {
        zoom: 14,
        disableDefaultUI: true,
        center: new google.maps.LatLng(55.726803, 37.561198),
        styles: this.dark ? [
          {
            featureType: 'all',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#ffffff',
              },
            ],
          },
          {
            featureType: 'all',
            elementType: 'labels.text.stroke',
            stylers: [
              {
                color: '#000000',
              },
              {
                lightness: 13,
              },
            ],
          },
          {
            featureType: 'administrative',
            elementType: 'all',
            stylers: [
              {
                hue: '#0042ff',
              },
              {
                saturation: '-100',
              },
              {
                lightness: '14',
              },
              {
                gamma: '0.00',
              },
              {
                weight: '0.01',
              },
            ],
          },
          {
            featureType: 'administrative',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#000000',
              },
            ],
          },
          {
            featureType: 'administrative',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#144b53',
              },
              {
                lightness: 14,
              },
              {
                weight: 1.4,
              },
            ],
          },
          {
            featureType: 'landscape',
            elementType: 'all',
            stylers: [
              {
                color: '#020f34',
              },
              {
                saturation: '-36',
              },
              {
                lightness: '14',
              },
              {
                gamma: '1.00',
              },
            ],
          },
          {
            featureType: 'landscape.man_made',
            elementType: 'all',
            stylers: [
              {
                saturation: '-13',
              },
              {
                lightness: '6',
              },
            ],
          },
          {
            featureType: 'landscape.natural',
            elementType: 'all',
            stylers: [
              {
                hue: '#0042ff',
              },
              {
                saturation: '26',
              },
            ],
          },
          {
            featureType: 'landscape.natural.landcover',
            elementType: 'all',
            stylers: [
              {
                hue: '#0042ff',
              },
            ],
          },
          {
            featureType: 'landscape.natural.terrain',
            elementType: 'all',
            stylers: [
              {
                hue: '#0042ff',
              },
              {
                saturation: '-11',
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'all',
            stylers: [
              {
                hue: '#0042ff',
              },
              {
                saturation: '8',
              },
              {
                gamma: '1.41',
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
              {
                color: '#0c4152',
              },
              {
                lightness: 5,
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'all',
            stylers: [
              {
                hue: '#0042ff',
              },
              {
                saturation: '49',
              },
              {
                lightness: '17',
              },
              {
                gamma: '0.06',
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [
              {
                gamma: '0.51',
              },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#000000',
              },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#0b434f',
              },
              {
                lightness: 25,
              },
            ],
          },
          {
            featureType: 'road.arterial',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#000000',
              },
            ],
          },
          {
            featureType: 'road.arterial',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#0b3d51',
              },
              {
                lightness: 16,
              },
            ],
          },
          {
            featureType: 'road.local',
            elementType: 'geometry',
            stylers: [
              {
                color: '#000000',
              },
            ],
          },
          {
            featureType: 'transit',
            elementType: 'all',
            stylers: [
              {
                color: '#081c54',
              },
              {
                saturation: '-63',
              },
              {
                lightness: '-58',
              },
              {
                gamma: '7.54',
              },
              {
                weight: '1.00',
              },
            ],
          },
          {
            featureType: 'transit',
            elementType: 'geometry',
            stylers: [
              {
                hue: '#0043ff',
              },
            ],
          },
          {
            featureType: 'transit',
            elementType: 'geometry.fill',
            stylers: [
              {
                hue: '#0043ff',
              },
            ],
          },
          {
            featureType: 'transit',
            elementType: 'geometry.stroke',
            stylers: [
              {
                weight: '0.01',
              },
              {
                hue: '#0043ff',
              },
            ],
          },
          {
            featureType: 'transit',
            elementType: 'labels',
            stylers: [
              {
                hue: '#0043ff',
              },
              {
                gamma: '5.88',
              },
            ],
          },
          {
            featureType: 'transit',
            elementType: 'labels.text.stroke',
            stylers: [
              {
                weight: '2.41',
              },
              {
                hue: '#0043ff',
              },
              {
                lightness: '-100',
              },
              {
                gamma: '0.00',
              },
            ],
          },
          {
            featureType: 'transit',
            elementType: 'labels.icon',
            stylers: [
              {
                lightness: '-33',
              },
            ],
          },
          {
            featureType: 'water',
            elementType: 'all',
            stylers: [
              {
                color: '#020f34',
              },
            ],
          },
        ] : '',
      };
      const mapSotbi = new google.maps.Map(this.$refs.map, mapOptions);
      new google.maps.Marker({ // eslint-disable-line no-new
        position: new google.maps.LatLng(55.722803, 37.561198),
        map: mapSotbi,
        clickable: false,
        title: 'Sotbi',
        icon: '/static/pin.png',
        width: 21,
      });
    },
    updateLang(lang) {
      const scriptWrap = document.querySelector('#google-maps-script');
      scriptWrap.innerHTML = '';
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://maps.googleapis.com/maps/api/js?callback=Sotbi.initMap&key=AIzaSyCyN9mhqH0qaSKSDaMD3-uV8hvOmSzlbnU';
      if (lang) {
        script.src += `&language=${lang}`;
      }
      scriptWrap.appendChild(script);
    },
  },
};
</script>

<style>
.map{
  margin-top: -150px;
  max-width: 100%;
  height: 500px;
  z-index: -1;
  width: 100%;
  
  &:before{
    background: linear-gradient(0deg, transparent, #020F34);
    position: absolute;
    height: 200px;
    width: 100vw;
    z-index: 999;
    content: '';
  }

  a{
    text-decoration: none;
    cursor: pointer;
    color: rgb(68, 68, 68);
  }

  @media (max-width: $mediaTiny) {
    .gm-style-cc{
      display: none;
    }
    .gmnoprint{
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Map.vue